import { render } from "./TrainerData.vue?vue&type=template&id=0235e5c8"
import script from "./TrainerData.vue?vue&type=script&lang=js"
export * from "./TrainerData.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__